"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSearchQueryParams = exports.parseQueryParams = void 0;
const query_string_1 = require("query-string");
const parseQueryParams = (locationSearch = window.location.search) => (locationSearch ? query_string_1.parse(locationSearch) : null);
exports.parseQueryParams = parseQueryParams;
const buildSearchQueryParams = (params = {}, options) => {
    if (Object.keys(params).length === 0)
        return '';
    else
        return `?${query_string_1.stringify(params, Object.assign({ sort: false }, options))}`;
};
exports.buildSearchQueryParams = buildSearchQueryParams;
